module.exports = __webpack_public_path__ + "static/media/hero-extened.4c9b3daf.jpg";